const LOCALE_SLUG_OVERRIDES: Record<string, Record<string, string>> = {
  fr: {
    '/contact': '/fr/nous-joindre',
    '/careers': '/fr/emplois',
  },
  de: {
    '/contact': '/de/kontakt',
    '/careers': '/de/karriere',
  },
};

export const generateLocalizedPath = (path: string, locale: string): string => {
  if (!path.startsWith('/')) {
    return path;
  }

  if (locale === 'en') {
    return path;
  }

  return LOCALE_SLUG_OVERRIDES[locale]?.[path] ?? `/${locale}${path}`;
};
